import { SelectOption } from '../adminmanagement/AdminRole';
import { PensionInfo } from '../verification/PeymeVerification.model';

export class Pensioner {
  Id!: string;
  PayMeUserId!: string;
  PensionerName!: string;
  ApprovedDate!: string;
  ApprovedBy!: string;
  AvailableAmount!: string;
  PensionAmount!: string;
  LastIssuedSalary!: string;
  LastCashoutDate!: string;
  Allowance!: string;
  PPANumber!: string;
  MobileNumber!: string;
  MobileNoVerified!: string;
  EmergencyMobileNumber!: string;
  MinistryName!: string;
  DepartmentName!: string;
  PensionType!: string;
  RegisteredDate!: string;
  UploadedFOS: string = '1';
  Address!: string;
  NRC!: string;
  SalaryRate!: string;
  TownshipCode!: string;
  DivisionCode!: string;
  Township!: string;
  Division!: string;
  ChangeRemark!: string;
  ProjectEntryNo!: string;
  FinancialYear!: string;
  DepartmentEntryNo!: string;
  DepartmentOutputDate!: string;
  DateOfBirth!: string;
  Position!: string;
  DepartmentEntryDate!: string;
  Status!: string;
  RetakeAssign!: number;
  DecisionReason!: string;
  DecisionBy!: string;
  LinkedPPA: (string | null)[] = [];
  ShowAllPPANumber: boolean = false;
  RenewLiveVerificationDate!: string;
  PensionGroup: (string | null)[] = [];
  PensionTypeList: (string | null)[] = [];
  IsOpenPinSinPay: boolean = false;
  PensionPPANo: any[] = [];
  RejectedStatus!: string;
  RejectedDate!: any;
  RejectedBy!: string;
  UpdatedDateTime!: string;
}

export class ImportedPensioner{
  Id!: string;
  PersonalFullName!: string;
  PersonalNrc!: string;
  PersonalDateOfBirthFormatted!: string;
  EmploymentPosition!: string;
  EmploymentMinistryName!: string;
  EmploymentDepartmentName!: string;
  PensionProjectEntryNo!: string;
  PensionPPANo!: string;
  PensionFinancialYear!: string;
}

export class PensionerDetail {
  //#region Pensioner Data
  Id!: string;
  PensionerName!: string;
  NRCNo!: string;

  PersonalFullName!: string;
  PersonalNrc!: string;
  PersonalDateOfBirthFormatted!: string;
  PersonalAge!: string;
  PersonalGender!: string;
  PersonalRace!: string;
  PersonalReligion!: string;
  PersonalFatherName!: string;
  PersonalMotherName!: string;
  PersonalRemark!: string;
  PersonalAddress!: string;

  EmploymentMilitaryId!: string;
  EmploymentPosition!: string;
  EmploymentMinistryName!: string;
  EmploymentDepartmentName!: string;
  EmploymentTotalServiceYear!: string;
  EmploymentDepartmentEntryNo!: string;
  EmploymentDepartmentEntryDateFormatted!: string;
  EmploymentDepartmentOutputNo!: string;
  EmploymentDepartmentOutputDateFormatted!: string;

  PensionSerialNo!: string;
  PensionProjectEntryNo!: string;
  PensionPPaNo!: string;
  PensionFinancialYear!: string;
  PensionTypeOfPension!: string;
  PensionAssignmentDateFormatted!: string;
  PensionExpirationDateFormatted!: string;
  PensionProjectEntryDateFormatted!: string;
  PensionCommencementDateFormatted!: string;

  DeceasedPensionerFullName!: string;
  DeceasedPensionerNRC!: string;
  DeceasedPensionerAge!: string;
  DeceasedPensionerGender!: string;
  DeceasedPensionerHeight!: string;
  DeceasedPensionerRace!: string;
  DeceasedPensionerReligion!: string;
  DeceasedPensionerFatherName!: string;
  DeceasedPensionerMotherName!: string;
  DeceasedPensionerState!: string;
  DeceasedPensionerTownship!: string;
  DeceasedPensionerAddress!: string;
  DeceasedPensionerRemark!: string;

  BeneficiaryPensionerName!: string;
  BeneficiaryPensionerNRC!: string;
  BeneficiaryPensionerFatherName!: string;
  BeneficiaryPensionerAge!: string;
  BeneficiaryPensionerRelation!: string;
  BeneficiaryPensionerDateOfBirthFormatted!: string;

  NRC!: string;
  DateOfBirth!: string;
  Age!: string;
  Gender!: string;
  Height!: string;
  Race!: string;
  Religion!: string;
  FatherName!: string;
  MotherName!: string;
  Division!: string;
  DivisionCode!: string;
  Township!: string;
  TownshipCode!: string;
  Address!: string;
  Remark!: string;

  //#region Employment Details
  MilitaryIdNumber!: string;
  Position!: string;
  MinistryName!: string;
  DepartmentName!: string;
  TotalServiceYear!: string;
  DepartmentEntryNo!: string;
  DepartmentEntryDate: string = '';
  DepartmentOutputNo!: string;
  DepartmentOutputDate!: string;
  //#endregion

  SerialNo!: string;
  ProjectEntryNo!: string;
  ProjectEntryDate!: string;
  PPANumber!: string;
  FinancialYear!: string;
  TypeOfPension!: string;
  AssignmentDate!: string;
  PensionCommencementDate!: string;
  PensionWithdrawalBank!: string;
  RelationWithPensioner!: string;

  SalaryRate!: string;
  LastIssuedSalary!: string;
  PensionAllowance!: string;
  GratuityAllowance!: string;
  ExpenseChildExpense!: string;
  ExpenseEducationExpense!: string;
  ExpenseHousing!: string;
  Bonus!: string;

  //backend(MT) side change some field name 
  SalaryLastIssuedSalary!: string;
  SalaryPensionAllowance!: string;
  SalaryGratuityAllowance!: string;
  SalaryChildExpense!: string;
  SalaryEducationExpense!: string;
  SalaryHousingExpesnse!: string;
  SalaryBonus!: string;
  Allowance!: string;

  NameOfFamilyPensioner!: string;
  NRCOfFamilyPensioner!: string;
  DobOfFamilyPensioner!: string;
  AgeOfFamilyPensioner!: string;
  GenderOfFamilyPensioner!: string;
  HeightOfFamilyPensioner!: string;
  RaceOfFamilyPensioner!: string;
  ReligionOfFamilyPensioner!: string;
  FatherNameOfFamilyPensioner!: string;
  MotherNameOfFamilyPensioner!: string;
  DivisionCodeOfFamilyPension!: string;
  TownshipCodeOfFamilyPension!: string;
  AddressOfFamilyPension!: string;
  RemarkOfFamilyPension!: string;

  //#region Deceased pensioner's Employment Details
  MilitaryIdNumberOfFamily!: string;
  PositionOfFamily!: string;
  MinistryOfFamily!: string;
  DepartmentOfFamily!: string;
  TotalServiceYearOfFamily!: string;
  DepartmentEntryNoOfFamily!: string;
  DepartmentEntryDateOfFamily!: string;
  DepartmentOutputNoOfFamily!: string;
  DepartmentOutputDateOfFamily!: string;
  //#endregion

  //#region Deceased pensioner's Pension Details
  SerialNoOfFamily!: string;
  ProjectEntryNoOfFamily!: string;
  ProjectEntryDateOfFamily!: string;
  PPANumberOfFamily!: string;
  StartFinancialYearOfFamily!: string;
  EndFinancialYearOfFamily!: string;
  FinancialYearOfFamily!: string;
  TypeOfPensionOfFamily!: string;
  AssignmentDateOfFamily!: string;
  PensionCommencementDateOfFamily!: string;
  PensionWithdrawalBankOfFamily!: string;
  DateOfDeadPensionerOfFamily!: string;
  //#endregion

  //#region Deceased pensioner's Pension Salary Details
  SalaryOfFamilyPension!: string;
  LastIssuedSalaryOfFamilyPension!: string;
  PensionAllowanceOfFamilyPension!: string;
  GratuityAllowanceOfFamilyPension!: string;
  //#endregion

  //#region Beneficiary Information
  NameOfBeneficiaryPensioner!: string;
  NRCOfBeneficiaryPensioner!: string;
  FatherNameOfBeneficiaryPensioner!: string;
  DOBOfBeneficiaryPensioner!: string;
  AgeOfBeneficiaryPensioner!: string;
  RelationOfBeneficiaryPensioner!: string;
  //#endregion

  MobileNumber!: string;
  DateOfDeadPensioner!: string;
  FamilyPensionCommencementDate!: string;
  ExpiryDateOfFamilyPension!: string;
  EnrollmentStatus!: string;
  LiveVerificationStatus!: string;
  LiveVerificationAt!: string;
  LiveVerificationExpireAt!: string;
  Status!: string;
  //#endregion

  ImportedBy!: string;

  ShowPensionerDetail: string = 'False';
  PensionGroup!: string;

  //#region Pensioner Registration
  RFullName!: string;
  RMobileNumber!: string;
  REmergencyMobileNumber!: string;
  RNRC!: string;
  RPPANumber!: string;
  RAddress!: string;
  RTownship!: string;
  RDivision!: string;
  RStatus: string = '---';
  //#endregion

  // EPensionCardFront!: string;
  // EPensionCardBack!: string;
  // PensionBookPage1!: string;
  // PensionBookPage2!: string;
  // PensionBookPage3!: string;
  // OtherAttachments : string[] = [];
  EPensionCardFront!: string;
  EPensionCardFrontLoading: string = '1';
  EPensionCardBack!: string;
  EPensionCardBackLoading: string = '1';
  PensionBookPage1!: string;
  PensionBookPage1Loading: string = '1';
  PensionBookPage2!: string;
  PensionBookPage2Loading: string = '1';
  PensionBookPage3!: string;
  PensionBookPage3Loading: string = '1';
  OtherAttachments: OtherAttachDto[] = [];

  IsEPension!: boolean;
  LinkedPPA: string[] = [];

  L1DecisionReasion!: string;
  L1DecisionReasionBy!: string;
  L1DecisionReasionAt!: string;
  L2DecisionReasion!: string;
  L2DecisionReasionBy!: string;
  L2DecisionReasionAt!: string;
  PDL1DecisionReasion!: string;
  PDL1DecisionReasionBy!: string;
  PDL1DecisionReasionAt!: string;
  PDL2DecisionReasion!: string;
  PDL2DecisionReasionBy!: string;
  PDL2DecisionReasionAt!: string;

  IsFamilyPension!: string;
  PensionInfo: any;
  UIDNo!: string;
}

export class PensionerDetailDto {
  //#region Pensioner Data
  IsOpen: string = '0';
  CalledBackEnd: string = '0';
  IsPensionViewOnly: boolean = true;
  IsPensionUpdate: boolean = false;
  NewOrOldNRC: string = '';
  NRCTownshipCodeList: SelectOption[] = [];

  Id!: string;
  PensionerName!: string;
  PersonalNrcStateCode!: string;
  PersonalNrcTownshipCode!: string;
  PersonalNrcType!: string;
  PersonalNrcSerialNo!: string;
  NRCNo!: string;
  NRC!: string;
  DateOfBirth!: string;
  Age!: string;
  Gender!: string;
  Height!: string;
  Race!: string;
  Religion!: string;
  FatherName!: string;
  MotherName!: string;
  Division!: string;
  DivisionCode!: string;
  Township!: string;
  TownshipCode!: string;
  Address!: string;
  Remark!: string;

  RelationToOriginPensioner!: string;
  DateOfDeadPensioner!: string;
  PrimaryPensionerDateOfDead!: string;
  ProminentMark!: string;
  SalaryOfFamilyPension!: string;
  FamilyPensionCommencementDate!: string;
  ExpiryDateOfFamilyPension!: string;

  //#region Employment Details
  MilitaryIdNumber!: string;
  Position!: string;
  MinistryName!: string;
  DepartmentName!: string;
  TotalServiceYear!: string;
  DepartmentEntryNo!: string;
  DepartmentEntryDate: string = '';
  DepartmentOutputNo!: string;
  DepartmentOutputDate!: string;
  //#endregion

  //#region Pensioner's Pension Details
  SerialNo!: string;
  ProjectEntryNo!: string;
  ProjectEntryDate!: string;
  PensionInfo!: PensionInfo;
  PPAInfo: PPAInfo = new PPAInfo();
  //#endregion
  FinancialYear!: string;
  StartFinancialYear!: string;
  EndFinancialYear!: string;
  TypeOfPension!: string;
  AssignmentDate!: string;
  PensionCommencementDate!: string;
  PensionWithdrawalBank!: string;
  RelationWithPensioner!: string;
  //#endregion

  //#region Pensioner's Pension Salary Details
  SalaryRate!: string;
  LastIssuedSalary!: string;
  PensionAllowance!: string;
  GratuityAllowance!: string;
  Allowance!: string;
  ExpenseChildExpense!: string;
  ExpenseEducationExpense!: string;
  ExpenseHousing!: string;
  Bonus!: string;
  //#endregion

  //#region Deceased pensioner's Personal Information
  NameOfFamilyPensioner!: string;
  NRCOfFamilyPensioner!: string;
  DobOfFamilyPensioner!: string;
  AgeOfFamilyPensioner!: string;
  GenderOfFamilyPensioner!: string;
  HeightOfFamilyPensioner!: string;
  RaceOfFamilyPensioner!: string;
  ReligionOfFamilyPensioner!: string;
  FatherNameOfFamilyPensioner!: string;
  MotherNameOfFamilyPensioner!: string;
  DivisionCodeOfFamilyPension!: string;
  TownshipCodeOfFamilyPension!: string;
  AddressOfFamilyPension!: string;
  RemarkOfFamilyPension!: string;
  //#endregion

  //#region Deceased pensioner's Employment Details
  MilitaryIdNumberOfFamily!: string;
  PositionOfFamily!: string;
  MinistryOfFamily!: string;
  DepartmentOfFamily!: string;
  TotalServiceYearOfFamily!: string;
  DepartmentEntryNoOfFamily!: string;
  DepartmentEntryDateOfFamily!: string;
  DepartmentOutputNoOfFamily!: string;
  DepartmentOutputDateOfFamily!: string;
  //#endregion

  //#region Deceased pensioner's Pension Details
  SerialNoOfFamily!: string;
  ProjectEntryNoOfFamily!: string;
  ProjectEntryDateOfFamily!: string;
  PPANumberOfFamily!: string;
  // DataFileld1OfFamily!: string;
  // DataFileld2OfFamily!: string;
  // DataFileld3OfFamily!: string;
  // DataFileld4OfFamily!: string;
  // DataFileld5OfFamily!: string;
  PPANoTypeOfFamily!: string;
  StartFinancialYearOfFamily!: string;
  EndFinancialYearOfFamily!: string;
  FinancialYearOfFamily!: string;
  TypeOfPensionOfFamily!: string;
  AssignmentDateOfFamily!: string;
  PensionCommencementDateOfFamily!: string;
  PensionWithdrawalBankOfFamily!: string;
  DateOfDeadPensionerOfFamily!: string;
  //#endregion

  //#region Deceased pensioner's Pension Salary Details
  LastIssuedSalaryOfFamilyPension!: string;
  PensionAllowanceOfFamilyPension!: string;
  GratuityAllowanceOfFamilyPension!: string;
  //#endregion

  //#region Beneficiary Information
  NameOfBeneficiaryPensioner!: string;
  NRCOfBeneficiaryPensioner!: string;
  FatherNameOfBeneficiaryPensioner!: string;
  DOBOfBeneficiaryPensioner!: string;
  AgeOfBeneficiaryPensioner!: string;
  RelationOfBeneficiaryPensioner!: string;
  //#endregion

  MobileNumber!: string;
  IsDataFound: 'true' | 'false' = 'false';
  IsChecked: string = '';
  IsCheckedData: boolean = false;
  IsMatched!: string;
  PensionGroup!: string;
  Status!: string;
  DecisionReasion!: string;
  L1DecisionReasion!: string;
  L1DecisionReasionBy!: string;
  L1DecisionReasionAt!: string;
  L2DecisionReasion!: string;
  L2DecisionReasionBy!: string;
  L2DecisionReasionAt!: string;
  PDL1DecisionReasion!: string;
  PDL1DecisionReasionBy!: string;
  PDL1DecisionReasionAt!: string;
  PDL2DecisionReasion!: string;
  PDL2DecisionReasionBy!: string;
  PDL2DecisionReasionAt!: string;
  // PDDecisionReasion!: string;
  // PDDecisionReasionBy!: string;
  // PDDecisionReasionAt!: string;

  IsEPension!: boolean;
  EPensionCardFront!: string;
  EPensionCardFrontLoading: string = '1';
  EPensionCardBack!: string;
  EPensionCardBackLoading: string = '1';
  PensionBookPage1!: string;
  PensionBookPage1Loading: string = '1';
  PensionBookPage2!: string;
  PensionBookPage2Loading: string = '1';
  PensionBookPage3!: string;
  PensionBookPage3Loading: string = '1';
  // OtherAttachments : string[] = [];
  IsFamilyPension!: string;
  OtherAttachments: OtherAttachDto[] = [];
  //#endregion

  validationErrors: string[] = [];
}

export class OtherAttachDto {
  AttachFile!: string;
  AttachFileLoading: string = '1';
}

export class pensionerFileUpload {
  XlsFile!: File;
  LoginUserId!: string;
}

export class ZipFileUpload {
  XlsFile: File | null = null;;
}

export class PPAInfo {
  PPANumber: string = '';
  DataFileld1: string = '';
  DataFileld2: string = '';
  DataFileld3: string = '';
  DataFileld4: string = '';
  DataFileld5: string = '';
  PPANoType: string = '';
  PPAOldOrNew: string = '';
}
export type PensionType =
  | 'civil'
  | 'political'
  | 'operation'
  | 'defense'
  | 'police'
  | 'other';
export class OtpRequest {
  MobileNumber: string = '';
  ReferenceId: string = '';
  OtpType: string = '';
}
export class OtpVerify extends OtpRequest {
  ConfirmationCode: string = '';
}
